import { useState, useEffect } from 'react';

export interface UserCoords {
  lat: number;
  lng: number;
}

export function calcDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function formatDistance(km: number): string {
  if (km < 1) return `${Math.round(km * 1000)}m`;
  if (km < 10) return `${km.toFixed(1)}km`;
  return `${Math.round(km)}km`;
}

let cached: UserCoords | null = null;

export function useUserLocation(): UserCoords | null {
  const [coords, setCoords] = useState<UserCoords | null>(cached);

  useEffect(() => {
    if (cached) return;
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        cached = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        setCoords(cached);
      },
      () => {},
      { timeout: 8000, maximumAge: 5 * 60 * 1000 },
    );
  }, []);

  return coords;
}
